<template>
  <svg
    id="Group_48997"
    data-name="Group 48997"
    xmlns="http://www.w3.org/2000/svg"
    width="36.24"
    height="38.836"
    viewBox="0 0 36.24 38.836"
  >
    <rect
      id="Rectangle_18749"
      data-name="Rectangle 18749"
      width="36.24"
      height="38.836"
      rx="5"
      fill=""
    />
    <path
      id="Path_30300"
      data-name="Path 30300"
      d="M0,45.379v3.257H13.029V45.379Z"
      transform="translate(11.605 -27.59)"
      fill="#000"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
